import React, { useState } from "react";
import { Button, Text, Modal } from "$components";
import { UserFormProvider } from "../context/UserFormContext";
import { useUserFormLogic } from "../hooks/useUserFormLogic";
import { UserFormBasicInfo } from "./UserFormBasicInfo";
import { UserFormPhones } from "./UserFormPhones";
import { UserFormAccess } from "./UserFormAccess";
import { useStyles } from "./styles";
import useJStyles from "$hooks/useJStyles";
import { UserFormProps } from "../types";

const UserForm: React.FC<UserFormProps> = ({
  onSubmit,
  onReset,
  user,
  error,
  isSubmitting = false,
  isCoordinator = true,
  canBeUser = false,
  hasToBeUser = false,
  canHaveTwoPhones = false,
  canBeApprover = false,
  activitiesOptions,
}) => {
  const classes = useStyles();
  const { jclasses } = useJStyles();
  const { form, isEmailValid, validateEmailExists } = useUserFormLogic(user);

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [pendingData, setPendingData] = useState<any>(null);

  const handleFormSubmit = (data: any) => {
    if (!user && isCoordinator) {
      setPendingData(data);
      setIsConfirmModalOpen(true);
    } else {
      onSubmit(data);
    }
  };

  const handleConfirm = () => {
    onSubmit(pendingData);
    setIsConfirmModalOpen(false);
    setPendingData(null);
  };

  const handleCancel = () => {
    setIsConfirmModalOpen(false);
    setPendingData(null);
  };

  const contextValue = {
    form,
    isCoordinator,
    canBeUser,
    hasToBeUser,
    canHaveTwoPhones,
    canBeApprover,
    activitiesOptions,
    error,
    isSubmitting,
  };

  return (
    <UserFormProvider value={contextValue}>
      <div className={jclasses.jWrapper}>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          className={classes.form}
        >
          <UserFormBasicInfo validateEmailExists={validateEmailExists} />
          <UserFormPhones />
          <UserFormAccess />

          {error && <Text className={classes.errorField}>{error}</Text>}

          <div className={classes.footerForm}>
            <Button color="secondary" onClick={onReset}>
              Annuler
            </Button>
            <Button
              onClick={() => form.handleSubmit(handleFormSubmit)()}
              disabled={isSubmitting || !isEmailValid}
            >
              {user ? "Enregistrer" : "Ajouter"}
            </Button>
          </div>
        </form>
        <Modal
          open={isConfirmModalOpen}
          onCancel={handleCancel}
          onValidate={handleConfirm}
          title="Confirmation"
          textValidate="Oui"
          textCancel="Non"
        >
          <Text>
            Vous êtes sur le point de créer un Coordinateur Logistique avec des
            droits administrateurs qui lui permettront d’accéder et d’agir sur
            l’ensemble des données confidentielles internes à Batail-Log.
            Souhaitez-vous poursuivre ?
          </Text>
        </Modal>
      </div>
    </UserFormProvider>
  );
};

export default UserForm;
